const DEFAULT_API_BASE_URL = 'https://www.heysens.cloud:8443'

function hasBrowserHostname() {
	return typeof window !== 'undefined' && window.location && window.location.hostname
}

function shouldUseCurrentHostname(hostname) {
	return hostname && hostname !== 'localhost' && hostname !== '127.0.0.1' && hostname !== '0.0.0.0'
}

export function getApiBaseUrl() {
	if (!hasBrowserHostname()) {
		return DEFAULT_API_BASE_URL
	}

	const { hostname } = window.location

	if (!shouldUseCurrentHostname(hostname)) {
		return DEFAULT_API_BASE_URL
	}

	return `https://${hostname}:8443`
}

export { DEFAULT_API_BASE_URL }
